import { OVERVIEW } from "../constants"

export function getDataOverviewSlides() {
  return [...Array(35)].map((e, i) => {
    return { pageA: i + 1, pageB: i + 36 <= OVERVIEW.NUM_PAGES ? i + 36 : 0 }
  })
}
